import { useCallback, useState } from 'react';

/**
 * ref로 dom을 가져왔을 경우 useEffect 상에서 dependency가 제대로 적용되지 않는 문제를 해결하기 위한 커스텀훅(useRef 대용)
 * @returns dom이 담기게 될 변수 / 태그의 ref에 넣어 dom을 가져오는 함수
 */
const useCallbackRef = (dependency: any[] = []) => {
	const [dom, setDom] = useState<HTMLElement | null>(null);

	const ref = useCallback(
		(node: HTMLElement) => {
			if (node !== null) setDom(node);
		},
		[...dependency],
	);

	return [dom, ref] as [HTMLElement | null, (node: HTMLElement | null) => void];
};

export default useCallbackRef;
